import type { AlqoveClient } from '../client';

export interface MessageThreadSummary {
  thread_id: string;
  order_id: string;
  counterparty_name: string | null;
  unread_count: number;
  last_message_snippet: string | null;
  last_message_at: string | null;
}

export interface MyThreadsResponse {
  data: MessageThreadSummary[];
}

export function createMeEndpoints(client: AlqoveClient) {
  return {
    threads() {
      return client.get<MyThreadsResponse>('/v1/me/threads');
    },
  };
}
